import { BookingRequestsStatus } from "../../../BookingRequest/typings/booking-requests.types";

/** Minimal shape for comparing approval transitions across catering / equipment / room layout rows. */
export type ServiceRowWithApprovalStatus = {
  id: number;
  status: BookingRequestsStatus;
};

export const hasStatusTransitionToApproved = (
  editedItems: readonly ServiceRowWithApprovalStatus[],
  originalItems: readonly ServiceRowWithApprovalStatus[]
) =>
  editedItems.some(editedItem => {
    const originalItem = originalItems.find(item => item.id === editedItem.id);
    if (!originalItem) return false;

    return (
      originalItem.status !== BookingRequestsStatus.APPROVED &&
      editedItem.status === BookingRequestsStatus.APPROVED
    );
  });
